import { LuDatabase, LuPencilLine } from "react-icons/lu";

export const ENV_FACTOR_VIEW_MODES = [
  { id: "reference", label: "Reference Data", icon: LuDatabase, desc: "DB source of truth — non-editable" },
  { id: "user_entry", label: "User Entry", icon: LuPencilLine, desc: "Editable dimensions and quantities" },
];

export const getVisibleFieldsForView = (activeView) => {
  switch (activeView) {
    case "reference":
      return [
        "source_row",
        "description",
        "default_unit",
        "gwp_unit",
        "biogenic_gwp",
        "factor",
        "unit_conversion_factor",
        "density",
        "ref_unit",
        "length", "length_unit",
        "width", "width_unit",
        "thickness", "thickness_unit",
        "volume",
        "density_kg_m3", "gwp_per_m3", "ref_mass_kg", "uncertainty_factor",
        "gwp_reference", "note", "year", "geography", "lcia_method", "recyclability",
      ];
    case "user_entry":
      return [
        "source_row",
        "type", "category", "sub_category",
        "description", "user_description",
        "quantity",
        "unit",
        "gwp_unit",
        "gwp_total",
        "biogenic_gwp",
        "biogenic_gwp_total",
        "mass",
        "uncertainty",
        "user_factor",
        "user_length", "user_length_unit",
        "user_width", "user_width_unit",
        "user_thickness", "user_thickness_unit",
        "user_volume", "user_volume_unit",
        "part_number",
        "gwp_reference",
        "note",
        "supplier_name",
        "is_hotspot",
      ];
    default:
      return null; // null = all allowed (full grid fallback)
  }
};
